// @flow

const parseSortDescriptions = (sortDescriptions: any): [string] | [] => {
  if (sortDescriptions && sortDescriptions.length === 0) {
    return [];
  }
  
  return sortDescriptions.map(({ property, ascending }) => ({
    property,
    ascending,
  }));
};

export { parseSortDescriptions };
